import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import './UnauthorizedPage.css';

interface UnauthorizedPageProps {
  link?: string;
}

const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({ link = '/' }) => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-box">
        <div className="lock-icon-wrapper">
          <div className="lock-icon">
            <Lock className="icon" />
          </div>
        </div>
        <h1 className="title">Unauthorized Access</h1>
        <p className="description">
          You do not have permission to view this page. If you believe this is a mistake, please contact the administrator.
        </p>
        <Link to={link} className="home-button">
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
